<template>
  <div class="about_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font">联系我们</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div class="ql-editor" v-html="htmlInfo"></div>
      </body>
    </div>
  </div>
</template>

<script>
import { getFirstcfg } from "@/network/api";
export default {
  data() {
    return {
      iconHeader: require("@/assets/images/pageico_1.png"),
      htmlInfo: "",
    };
  },
  mounted() {
    let formData = new FormData();
    formData.append("dpCode", "DP04");
    getFirstcfg(formData).then((res) => {
      if (res.code == 200) {
        this.htmlInfo = res.data.stContent;
      }
    });
  },
};
</script>


<style scoped>
.about_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
p {
  text-align: left;
  text-indent: 24px;
  font-size: 16px;
  color: #787878;
  line-height: 24px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
}
.ab_foot {
  margin-top: 24px;
  background: white;
  margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/AboutWe.vue